import React from 'react';
import { Table } from 'semantic-ui-react';
import { firstErrorMessage } from '@/utils/errors';
import { states } from '@/constants/lifecycle';
import TableHeader from '@/components/table/TableHeader';
import RolesTableColumns from '../containers/RolesTableColumns';

const RolesTableHeader = ({
  category,
  children,
  columns,
  hideColumns,
  readErrors,
  readStatus,
  roles,
}) => (
  <Table.Header fullWidth>
    <TableHeader
      isLoading={readStatus === states.PENDING}
      error={firstErrorMessage(readErrors)}
      numberOfColumns={columns.length}
    >
      {children}
    </TableHeader>
    {!hideColumns && <RolesTableColumns category={category} items={roles} columns={columns} />}
  </Table.Header>
);

export default RolesTableHeader;
